import * as types from "../constants/actionConstants";
import * as portalTypes from "../portal/constants/actionConstants";
import {
    activeEditorOriginMatches,
    captureEditorOrigin
} from "../utilities/editorInstanceOwnership";


export function addAnswer (isGroupMode, answer, depth = 0) {

    let answerOption = {
        templateKey: "",
        optionText: "",
        importActionKeys: [],
        importCategoryKeys: [],
        importGroupKeys: [],
        metadata: {},
        ...answer
    };

    return (dispatch) => {
        dispatch({type: isGroupMode ? types.ANSWER_EDITOR_ADD_GROUP_ANSWER : types.ANSWER_EDITOR_ADD_QUESTION_ANSWER,
            answer: answerOption,
            depth: depth
        });
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function updateAnswer (isGroupMode, answer, index, depth = 0) {
    //debugger; // SSSSS Show Group Testing
    return (dispatch) => {
        dispatch({type: isGroupMode ? types.ANSWER_EDITOR_UPDATE_GROUP_ANSWER : types.ANSWER_EDITOR_UPDATE_QUESTION_ANSWER,
            answer: answer,
            index: index,
            depth: depth
        });

        // if (isGroupMode) {
        //     if (props.createMode) {
        //         dispatch(addGroupShowGroupKeys());
        //     } else {
        //         dispatch(addGroupTemplateShowGroupKeys());
        //     }
        // }

        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function removeAnswer (isGroupMode, index, depth = 0) {
    return (dispatch) => {
        dispatch({type: isGroupMode ? types.ANSWER_EDITOR_REMOVE_GROUP_ANSWER : types.ANSWER_EDITOR_REMOVE_QUESTION_ANSWER,
            index: index,
            depth: depth
        });
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function reorderAnswer (isGroupMode, isUp, currentIndex, depth = 0) {
    return (dispatch) => {
        dispatch({type: isGroupMode ? types.ANSWER_EDITOR_REORDER_GROUP_ANSWER : types.ANSWER_EDITOR_REORDER_QUESTION_ANSWER,
            isUp: isUp,
            currentIndex: currentIndex,
            depth: depth
        });
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function setShowGroup (newShowGroupAdded, answerIndex, parentOrigin = null) {
    const origin = captureEditorOrigin(parentOrigin);

    return (dispatch, getState) => {
        if (origin && !activeEditorOriginMatches(origin, getState())) {
            return;
        }
        dispatch({type: types.ANSWER_SHOW_GROUP_SUCCESS,
            newShowGroupAdded,
            answerIndex,
            origin
        });
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };

}

export function clearShowGroup (newShowGroupAdded, answerIndex, parentOrigin = null) {
    const origin = captureEditorOrigin(parentOrigin);

    return (dispatch, getState) => {
        if (origin && !activeEditorOriginMatches(origin, getState())) {
            return;
        }
        dispatch({type: types.ANSWER_SHOW_GROUP_CLEAR,
            newShowGroupAdded,
            answerIndex,
            origin
        });
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };

}

export function incrementPortalCount () {
    return (dispatch) => {
        dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
    };
}